module.exports = __webpack_public_path__ + "static/media/dongcheng@3x.43fe16d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list/dongcheng@3x.png
// module id = 717
// module chunks = 0